import { runDemo } from "../shared/demoRunner";
import { createWaterMaterialScene } from "./scene";

runDemo({ createScene: createWaterMaterialScene });
